import React from 'react'
import { useContainerWidth, Paragraph } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import CountUp from 'react-countup'
import { number, string } from 'prop-types'
import animation from '../../../../../shared/services/cssAnimations'

export default function CountryPercentage({ percent, alpha2, color }) {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()
  const progressBarStyle = css`
    width: 100%;
    height: 18px;
    border-radius: 10px;
    background-color: #ccc;
    overflow: hidden;
  `
  const percentStyle = css`
    font-size: 28px;
    color: ${color};
    margin-top: 4px;
  `

  const countryElemementStyle = css`
    margin: ${atWidth({ default: '12px', xl: '20px' })};
  `
  // eslint-disable-next-line react/no-unstable-nested-components
  const Range = ({ percentRange, fillColor }) => {
    const rangeStyle = css`
      height: 100%;
      width: ${percentRange < 5 ? 8 : percentRange}%;
      border-radius: 10px;
      background-color: ${fillColor};
      animation: ${animation('grow-from-left')} 1800ms;
    `
    return <div css={rangeStyle} />
  }

  // eslint-disable-next-line react/no-unstable-nested-components
  const ProgressBar = ({ percentRange, fillColor }) => {
    return (
      <div css={progressBarStyle}>
        <Range percentRange={percentRange} fillColor={fillColor} />
      </div>
    )
  }

  return (
    <div css={countryElemementStyle}>
      <ProgressBar percentRange={percent} fillColor={color} />
      <div>
        <div css={percentStyle}>
          <strong>
            <CountUp end={percent} duration={2} />%
          </strong>
        </div>
        <Paragraph size="sm">{t(`global.countries.country${alpha2}`, alpha2)}</Paragraph>
      </div>
    </div>
  )
}

CountryPercentage.propTypes = {
  percent: number.isRequired,
  alpha2: string.isRequired,
  color: string,
}
